// import React, { useState } from 'react'
// import DynamicForm from '../../../../customformComponent/customForm/DynamicForm'
// import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
// import axiosInstance from '../../../../services/api/API';

// const QuantityAdd = ({showroomIdVal, pendingValData, poDetailsId, poIdValue, setSerialDrawer}) => {

//     console.log(pendingValData, "PENDINGDATA")

//     const [formData, setFormData] = useState({});
//     const [validationErrors, setValidationErrors] = useState({});

//     const authToken = localStorage.getItem("authToken");

//     const handleFormSubmit = async (formData) => {
        
//         const errors = {};
//         let isValid = true;
    
//         PurchaseInputs.forEach((field) => {
//           if (field.validation && field.validation.required) {
//             if (!formData[field.name]) {
//               errors[field.name] = "This field is required";
//               isValid = false;
//             }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
//               errors[field.name] = field.validation.message;
//               isValid = false;
//             }
//           }
//         });

//         const totalQuantity =
//         parseInt(formData.missing_qty || 0, 10) +
//         parseInt(formData.defective_qty || 0, 10) +
//         parseInt(formData.good_qty || 0, 10);

//     // Check if total quantity exceeds pendingValData
//         if (totalQuantity > pendingValData) {
//             errors.totalQuantity = `The total quantity cannot exceed ${pendingValData}. You have entered ${totalQuantity}.`;
//             isValid = false;
//         }

    
//         if (!isValid) {
//           setValidationErrors(errors);
//           return;
//         }
//         console.log("formData",formData);
//         try {
    
//           const payload = {
//             po_id:poIdValue,
//             po_details_id:poDetailsId,
//             missing_qty: formData.missing_qty,
//             defective_qty:formData.defective_qty,
//             good_qty:formData.good_qty,
//             showroom_id: showroomIdVal,
//           }
    
//           const response = await axiosInstance.post('/Postockin/postockincreate', payload,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${authToken}`,
//             }
//           }
//         );
//         if (response.status === 200){
//             setSerialDrawer(false)
//         }
 
//         } catch (error) {
//           console.error('Error adding unit:', error);
//         } finally {
//         }
//       };


//     const PurchaseInputs = [
//         {
//           name: "missing_qty",
//           label: "Missing Quantity",
//           placeholder:"Enter Quantity Number",
//           type: "text",
//           required: true,
//           gridClass: "col-lg-8",
          
//           validation: {
//             maxValue: pendingValData,
//             required: true,
//           },
//         },
//         {
//           name: "defective_qty",
//           label: "Defective Quantity",
//           placeholder:"Enter Quantity Number",
//           type: "text",
//           required: true,
//           gridClass: "col-lg-8",
//           validation: {
//             maxValue: pendingValData,
//             required: true,
//           },
//         },
//         {
//             name: "good_qty",
//             label: "Good Quantity",
//             placeholder:"Enter Quantity Number",
//             type: "text",
//             required: true,
//             gridClass: "col-lg-8",
//             validation: {
//                 maxValue: pendingValData,
//                 required: true,
//               },
//           }
//       ];

//   return (
//     <div>
//         <DynamicForm 
//         formConfig={PurchaseInputs}
//         formData={formData}
//         setFormData={setFormData}
//         onSubmit={handleFormSubmit}
//         validationErrors={validationErrors}
//         setValidationErrors={setValidationErrors}
//         />
//         <button
//           onClick={() => { handleFormSubmit(formData)}}
//           className="submit-btn"
//         >
//           Submit
//         </button>
//         {validationErrors?.totalQuantity && (
//         <div className="error-message">
//             {validationErrors.totalQuantity}
//         </div>
//         )}
//     </div>
//   )
// }

// export default QuantityAdd
import React, { useState } from 'react';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
import axiosInstance from '../../../../services/api/API';

const QuantityAdd = ({ showroomIdVal, pendingValData, poDetailsId, poIdValue, setSerialDrawer }) => {

  console.log(pendingValData, "PENDINGDATA");

  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const authToken = localStorage.getItem("authToken");

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    PurchaseInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    const missingQty = parseInt(formData.missing_qty || 0, 10);
    const defectiveQty = parseInt(formData.defective_qty || 0, 10);
    const goodQty = parseInt(formData.good_qty || 0, 10);

    const totalQuantity = missingQty + defectiveQty + goodQty;

    // Check if total quantity exceeds pendingValData
    if (totalQuantity > pendingValData) {
      errors.totalQuantity = `The total quantity cannot exceed ${pendingValData}. You have entered ${totalQuantity}.`;
      isValid = false;
    }

    // Ensure the total quantity is greater than 0
    if (totalQuantity <= 0) {
      errors.totalGreaterThanZero = "The total quantity must be greater than 0.";
      isValid = false;
    }

    // Ensure all quantities are greater than or equal to 0
    if (missingQty < 0 || defectiveQty < 0 || goodQty < 0) {
      errors.quantity = "Quantities cannot be negative.";
      isValid = false;
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("formData", formData);
    try {
      const payload = {
        po_id: poIdValue,
        po_details_id: poDetailsId,
        missing_qty: formData.missing_qty?formData.missing_qty:0,
        defective_qty: formData.defective_qty?formData.defective_qty:0,
        good_qty: formData.good_qty?formData.good_qty:0,
        showroom_id: showroomIdVal,
      };

      const response = await axiosInstance.post(
        '/Postockin/postockincreate',
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        }
      );

      if (response.status === 200) {
        setSerialDrawer(false);
      }

    } catch (error) {
      console.error('Error adding unit:', error);
    }
  };

  const PurchaseInputs = [
    {
      name: "missing_qty",
      label: "Missing Quantity",
      placeholder: "Enter Missing Quantity",
      type: "text",
      required: false,
      gridClass: "col-lg-8",
      validation: {
        maxValue: pendingValData,
        required: false,
      },
    },
    {
      name: "defective_qty",
      label: "Defective Quantity",
      placeholder: "Enter Defective Quantity",
      type: "text",
      required: false,
      gridClass: "col-lg-8",
      validation: {
        maxValue: pendingValData,
        required: false,
      },
    },
    {
      name: "good_qty",
      label: "Good Quantity",
      placeholder: "Enter Good Quantity",
      type: "text",
      required: false,
      gridClass: "col-lg-8",
      validation: {
        maxValue: pendingValData,
        required: false,
      },
    },
  ];

  return (
    <div>
      <DynamicForm
        formConfig={PurchaseInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />
      <button
        onClick={() => { handleFormSubmit(formData); }}
        className="submit-btn"
      >
        Submit
      </button>
      {validationErrors?.totalQuantity && (
        <div className="error-message">
          {validationErrors.totalQuantity}
        </div>
      )}
      {validationErrors?.totalGreaterThanZero && (
        <div className="error-message">
          {validationErrors.totalGreaterThanZero}
        </div>
      )}
      {validationErrors?.quantity && (
        <div className="error-message">
          {validationErrors.quantity}
        </div>
      )}
    </div>
  );
};

export default QuantityAdd;

